import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: "EarlyYearDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      categories: [],
      terms: {},
      academicYearId: null,
      studentId: null,
      student_name: '',
      noDataMsg: CONFIG.NO_DATA_EXIST,
      inputData: {
        display_status: {},
        item_status: {}
      },
    }
  },

  computed: {
    studentExists() {
      return this.student_name && 
             this.student_name.trim() !== '' && 
             this.academicYearId && 
             this.terms && 
             Object.keys(this.terms).length > 0;
    },

    groupedCategories() {
      if (!Array.isArray(this.categories) || this.categories.length === 0) {
        return [];
      }

      return this.categories.reduce((groups, category) => {
        const title = category.category_title || '';
        const currentGroup = groups[groups.length - 1];

        if (!currentGroup || currentGroup.title !== title) {
          groups.push({
            title,
            categories: []
          });
        }

        groups[groups.length - 1].categories.push(category);
        return groups;
      }, []);
    }
  },

  methods: {
    getDisplayStatusText(statusId) {
      if (!statusId) return '-';
      return CONFIG.REPORT_CARD_DISPLAY_STATUS[statusId];
    },

    getEarlyYearCategories() {
      this.isLoading = true;
      axios.get('early-year/categories', {
        params: {
          student_id: this.studentId,
          academic_year_id: this.academicYearId
        }
      })
        .then(res => {
          this.categories = res.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.error('Error fetching early year categories:', error);
        });
    },

    getTermsByAcademicYear() {
      axios.get(`early-year/terms/${this.academicYearId}`)
        .then(res => {
          this.terms = res.data;
        })
        .catch(error => {
          console.error('Error fetching terms:', error);
        });
      this.loadExistingData();
    },

    loadExistingData() {
      this.isLoading = true;
      axios.get(`early-year/get-report-card/${this.studentId}/${this.academicYearId}`)
        .then(res => {
          if (res.data) {
            this.student_name = res.data.student.student_name;

            res.data.report_card.forEach(grading => {
              this.$set(this.inputData.display_status, grading.term_id, grading.status);

              grading.details.forEach(detail => {
                const key = `${grading.term_id}_${detail.reportcard_item_id}`;
                this.$set(this.inputData.item_status, key, detail.grading);
              });
            });
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error loading existing data:', error);
          this.isLoading = false;
        });
    },

    downloadPDF() {
      if (!this.studentId || !this.academicYearId) {
        alert('Student or Academic Year information missing');
        return;
      }

      this.isLoading = true;

      axios({
        url: `/early-year/downloadPDF/${this.studentId}/${this.academicYearId}`,
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${this.student_name}'s_report_card.pdf`);
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);

          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error downloading PDF:', error);
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    showEdit() {
      this.$router.push({
        name: 'earlyYearEdit',
        params: { academicYearId: this.academicYearId , id: this.studentId }
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.academicYearId = this.$route.params.academicYearId;
    this.studentId = this.$route.params.id;
    this.getTermsByAcademicYear();
    this.getEarlyYearCategories();
  }
};
